// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#agencyConnectionModal {
    width: 50%;
    height: 60%;
}

#agencyConnectionModal .content {
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 1000px;
}

#agencyConnectionModal .content h3 {
    margin: 0;
}

/* Agency Connector */
.agencyConnector {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 20px 0 40px 0;
}

.connectedAgency {
    display: flex;
    align-items: center;
    position: relative;
    background: #f9f9f9;
    border: 1px solid #ccc;
    padding: 5px 10px;
    border-radius: 4px;
}

.connectedAgency p {
    margin: 0;
}

.connectedAgency span {
    line-height: 122%;
    transform: scale(1.5);
    margin-left: 10px;
}

.connectedAgency .hoverInfo {
    position: absolute;
    background-color: #f0f0f0;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    top: 25px; /* Adjust as necessary */
    left: 0;
    white-space: nowrap;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Agency Input */
.agencyInput {
    position: relative;
    width: 100%;
}

.agencyInput input {
    width: calc(100% - 20px);
    padding: 10px 8px;
    font-size: 16px;
    border: none;
    border-radius: 4px;
    box-sizing: border-box;
}

.agencyInput input:focus {
    outline-style: none
}

/* Suggestions */
.suggestion {
    position: absolute;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: calc(100% - 20px);
    max-height: 260px;
    overflow-y: auto;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.suggestion div {
    padding: 10px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
}

.suggestion div:hover {
    background: #f0f0f0;
}

/* Connection Controller */
.connectionController {
    text-align: center;
}

.connectionController .blackBtn {
    background-color: #000;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.connectionController .blackBtn:hover {
    background-color: #333;
}

@media screen and (max-width: 900px) {
    #agencyConnectionModal {
        width: 90%;
        height: 90%;
    }
}

@media screen and (max-width: 600px) {
    #agencyConnectionModal {
        height: 60%;
    }
    .agencyInput input{
        font-size: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Modal_AgencyConnection.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,SAAS,EAAE,wBAAwB;IACnC,OAAO;IACP,mBAAmB;IACnB,aAAa;IACb,wCAAwC;AAC5C;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["#agencyConnectionModal {\n    width: 50%;\n    height: 60%;\n}\n\n#agencyConnectionModal .content {\n    padding: 20px 16px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 1000px;\n}\n\n#agencyConnectionModal .content h3 {\n    margin: 0;\n}\n\n/* Agency Connector */\n.agencyConnector {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin: 20px 0 40px 0;\n}\n\n.connectedAgency {\n    display: flex;\n    align-items: center;\n    position: relative;\n    background: #f9f9f9;\n    border: 1px solid #ccc;\n    padding: 5px 10px;\n    border-radius: 4px;\n}\n\n.connectedAgency p {\n    margin: 0;\n}\n\n.connectedAgency span {\n    line-height: 122%;\n    transform: scale(1.5);\n    margin-left: 10px;\n}\n\n.connectedAgency .hoverInfo {\n    position: absolute;\n    background-color: #f0f0f0;\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    top: 25px; /* Adjust as necessary */\n    left: 0;\n    white-space: nowrap;\n    z-index: 1000;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Agency Input */\n.agencyInput {\n    position: relative;\n    width: 100%;\n}\n\n.agencyInput input {\n    width: calc(100% - 20px);\n    padding: 10px 8px;\n    font-size: 16px;\n    border: none;\n    border-radius: 4px;\n    box-sizing: border-box;\n}\n\n.agencyInput input:focus {\n    outline-style: none\n}\n\n/* Suggestions */\n.suggestion {\n    position: absolute;\n    background: #fff;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    width: calc(100% - 20px);\n    max-height: 260px;\n    overflow-y: auto;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n}\n\n.suggestion div {\n    padding: 10px;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n}\n\n.suggestion div:hover {\n    background: #f0f0f0;\n}\n\n/* Connection Controller */\n.connectionController {\n    text-align: center;\n}\n\n.connectionController .blackBtn {\n    background-color: #000;\n    color: #fff;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.connectionController .blackBtn:hover {\n    background-color: #333;\n}\n\n@media screen and (max-width: 900px) {\n    #agencyConnectionModal {\n        width: 90%;\n        height: 90%;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    #agencyConnectionModal {\n        height: 60%;\n    }\n    .agencyInput input{\n        font-size: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
